import React, { Component } from 'react';
import Loader from 'react-loader';
import styles from './styles.scss';

const options = {
  lines: 12,
  length: 20,
  width: 10,
  radius: 30,
  corners: 1,
  rotate: 0,
  direction: 1,
  color: '#fff',
  speed: 1,
  trail: 60
};

class LoadingSpinner extends Component {

  constructor(props) {
    super(props);
    this.state = {
      exist: false,
      transition: 'out', // 'in'
      transitionTimeout: null,
    };
  }

  componentWillUpdate(newProps, newState) {
    if (newProps.loading !== this.props.loading) {
      clearTimeout(this.state.transitionTimeout);
      if (newProps.loading) {
        this.setState({
          exist: true,
          transition: 'out',
          transitionTimeout: setTimeout(() => {
            this.setState({
              transition: 'in',
              transitionTimeout: null,
            });
          }, 10),
        });
      } else {
        this.setState({
          transition: 'out',
          transitionTimeout: setTimeout(() => {
            this.setState({
              exist: false,
              transitionTimeout: null,
            });
          }, 400),
        });
      }
    }
  }

  render() {
    const classNames = ([
      styles.blocker,
      this.state.transition === 'in' ? styles.show : styles.hide,
    ]).join(' ');
    return (
      this.state.exist ?
      <div className={classNames}>
        <Loader className="loader" options={options}>
          {
            this.props.message !== '' ?
            <span>{this.props.message}</span> :
            null
          }
        </Loader>
      </div> :
      null
    );
  }

};

LoadingSpinner.defaultProps = {
  loading: false,
  message: '',
};

export default LoadingSpinner;
